import { render, staticRenderFns } from "./act.vue?vue&type=template&id=689707f4&scoped=true"
import script from "./act.vue?vue&type=script&lang=js"
export * from "./act.vue?vue&type=script&lang=js"
import style0 from "./act.vue?vue&type=style&index=0&id=689707f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689707f4",
  null
  
)

export default component.exports